import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProgressIndicatorService {
  isProgressIndicator = signal<boolean>(false);
  progressIndicatorMessage = signal<string>('');
}
